module.exports = __webpack_public_path__ + "img/胡世民.0b0f98e9.jpg";